import { createSlice } from '@reduxjs/toolkit'
import {
  sectionsSliceConfig as sectionsSliceBaseConfig,
  sectionsSliceExtraReducers as sectionsSliceBaseExtraReducers,
  createTableSections,
} from 'apps/formsCreationKit/store/reducers/entities/sections'
import {
  addPdf,
  resetPdf,
  createElement,
  updateElement,
  deleteElement,
  replacePdf,
  createTable,
  deleteTable,
} from 'apps/studio/store/actions/sharedActions'

const createSectionIfNecessary = (state, action) => {
  const { section } = action.payload

  if (section) {
    const updatedState = [...state, section]
    return updatedState.sort((a, b) => a.position - b.position)
  }
}

export const deleteSectionIfNecessary = (state, action) => {
  const { section: sectionToDelete } = action.payload
  const { id } = sectionToDelete
  return state.filter(section => section.id !== id)
}

export const initialState = []

export const sectionsSliceStudioExtraReducers = builder => {
  builder
    .addCase(createElement, createSectionIfNecessary)
    .addCase(createTable, createTableSections)
    .addCase(updateElement, (state, action) => {
      const { section, sectionToDelete } = action.payload

      let updatedState = state

      if (sectionToDelete) {
        updatedState = updatedState.filter(
          section => section.id !== sectionToDelete
        )
      }

      return section ? [...updatedState, section] : updatedState
    })
    .addCase(deleteElement, deleteSectionIfNecessary)
    .addCase(deleteTable, (state, action) => {
      const { outerSection, innerSection } = action.payload
      const idsToRemove = new Set([outerSection.id, innerSection.id])
      return state.filter(section => !idsToRemove.has(section.id))
    })
    .addCase(addPdf, () => [])
    .addCase(resetPdf, () => [])
    .addCase(replacePdf, (state, action) => {
      const { removedSectionIds } = action.payload
      return state.filter(section => !removedSectionIds.includes(section.id))
    })
}

export const sectionsSliceStudioConfig = {
  ...sectionsSliceBaseConfig,
  extraReducers: builder => {
    sectionsSliceBaseExtraReducers(builder)
    sectionsSliceStudioExtraReducers(builder)
  },
}

export const sectionsSlice = createSlice(sectionsSliceStudioConfig)
export const { reducer: sectionsReducer } = sectionsSlice
